var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcon6 = function SvgIcon6(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 48,
    viewBox: "0 0 67 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47.8291H16.3496V15.7515H0V47.8291Z",
    fill: "#8e939f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0564 3.44824H19.8463L18.291 40.5737H26.6121L25.0564 3.44824Z",
    fill: "#8e939f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1406 3.44808H25.7607V0H19.1406V3.44808Z",
    fill: "#cdd2d7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6211 19.6272H51.3409V18.498H32.6211V19.6272Z",
    fill: "#cdd2d7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6211 15.0742H51.3409V13.9448H32.6211V15.0742Z",
    fill: "#cdd2d7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6211 19.6273H33.7904V13.9448H32.6211V19.6273Z",
    fill: "#cdd2d7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5625 19.6273H37.7321V13.9448H36.5625V19.6273Z",
    fill: "#cdd2d7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.291 19.6273H42.4603V13.9448H41.291V19.6273Z",
    fill: "#cdd2d7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0176 19.6273H47.1869V13.9448H46.0176V19.6273Z",
    fill: "#cdd2d7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6157 18.6194L37.0358 19.199L32.8574 15.0206L33.437 14.4407L37.6157 18.6194Z",
    fill: "#cdd2d7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7605 18.6194L41.1806 19.199L37.002 15.0206L37.5818 14.4407L41.7605 18.6194Z",
    fill: "#cdd2d7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4653 18.6194L45.8857 19.199L41.707 15.0206L42.2869 14.4407L46.4653 18.6194Z",
    fill: "#cdd2d7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6099 18.6194L50.0303 19.199L45.8516 15.0206L46.4315 14.4407L50.6099 18.6194Z",
    fill: "#cdd2d7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2429 9.86792H50.2868L49.4043 23.5879H54.1257L53.2429 9.86792Z",
    fill: "#cdd2d7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.707 37.308H36.4723V19.0632H34.707V37.308Z",
    fill: "#cdd2d7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92188 23.4183H12.4744V18.9153H9.92188V23.4183Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92188 38.7577H12.4744V34.2544H9.92188V38.7577Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.046 23.4187H47.737L45.2307 25.5188V43.9729H36.6925V32.6726L28.4096 39.6122L11.4863 40.3825V47.9321H36.6925V47.8722H45.2307V47.9321H66.3925V36.5537L57.046 23.4187Z",
    fill: "#1d2535"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon6.04dcaaf2.svg";
export { ForwardRef as ReactComponent };